import { createFileRoute } from '@tanstack/react-router';

import { SideMenuLayout } from '@/components/SideMenuLayout';
import { ProcessView } from '@/components/processes/ProcessView';

function RouteComponent() {
  return (
    <SideMenuLayout>
      <ProcessView />
    </SideMenuLayout>
  );
}

export const Route = createFileRoute('/_authenticated/_management/vorgaenge/$adminLevelId/$processId/')({
  component: RouteComponent,
});
